<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align:center;">For Gary and Shell</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedi.vue?2b28d74b